/**
 * @generated SignedSource<<9530b9b6ebe6cd373dd111dff57e582f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AtlasProjectGroupHeader$data = {
  readonly project: {
    readonly hasPermission: boolean | null | undefined;
    readonly id: string;
    readonly key: string | null | undefined;
    readonly name: string | null | undefined;
    readonly privateProject: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "AtlasProjectGroupHeader";
};
export type AtlasProjectGroupHeader$key = {
  readonly " $data"?: AtlasProjectGroupHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"AtlasProjectGroupHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "AtlasProjectGroupHeader",
  "selections": [
    {
      "concreteType": "JiraTownsquareProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "kind": "ScalarField",
          "name": "privateProject"
        },
        {
          "kind": "ScalarField",
          "name": "hasPermission"
        },
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraJqlTownsquareProjectFieldValue"
};

(node as any).hash = "c27350930685be9210c02f7969e765f7";

export default node;
